import { Dispatch, FC, SetStateAction } from 'react';
import { useTranslation } from 'react-i18next';

import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  IconButton,
  TextField,
} from '@mui/material';
import { Close as CloseIcon } from '@mui/icons-material';

type ConfirmModalProps = {
  open: boolean;
  onClose: () => void;
  onSuccess: () => void;
  onCancel: () => void;
  isLoading: boolean;
  name: string;
  setName: Dispatch<SetStateAction<string>>;
};

export const CreateTypeModal: FC<ConfirmModalProps> = (props) => {
  const { open, onClose, onSuccess, onCancel, isLoading, name, setName } = props;
  const { t } = useTranslation();

  return (
    <Dialog open={open} onClose={onClose} PaperProps={{ sx: { minWidth: '380px' } }}>
      <DialogTitle>{t('company-types.actions.create.modal.title')}</DialogTitle>
      <IconButton
        aria-label="close"
        sx={{
          position: 'absolute',
          right: 8,
          top: 8,
          color: (theme) => theme.palette.grey[500],
        }}
        onClick={onClose}
      >
        <CloseIcon />
      </IconButton>

      <DialogContent>
        <TextField
          name="amount"
          value={name}
          onChange={(e) => setName(e.target.value)}
          label={t('company-types.actions.create.modal.field-text')}
          fullWidth
        />
      </DialogContent>

      <DialogActions>
        <Button variant="contained" onClick={() => onSuccess()} disabled={isLoading}>
          {t('company-types.actions.create.modal.create-btn')}
        </Button>
        <Button variant="outlined" onClick={() => onCancel()} disabled={isLoading}>
          {t('company-types.actions.create.modal.cancel-btn')}
        </Button>
      </DialogActions>
    </Dialog>
  );
};
